import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLargeLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-large-left, chev left, last"><path fillRule="evenodd" clipRule="evenodd" d="M14.6335 2.10546C14.9895 2.31716 15.1065 2.77739 14.8948 3.13342L9.69869 11.8724C9.65187 11.9511 9.65187 12.0492 9.69869 12.1279L14.8948 20.8668C15.1065 21.2228 14.9895 21.6831 14.6335 21.8948C14.2774 22.1065 13.8172 21.9895 13.6055 21.6334L8.40939 12.8945C8.08164 12.3433 8.08164 11.657 8.40939 11.1058L13.6055 2.36681C13.8172 2.01078 14.2774 1.89377 14.6335 2.10546Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronLargeLeft;
